module.exports = __webpack_public_path__ + "static/media/truthable.593416b7.png";